import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { v4 as uuidv4 } from "uuid"
import { Button, Card, CardBody, Col, Container, Row, Table } from "reactstrap"
import { StorageImage } from "@aws-amplify/ui-react-storage"

import CustomPlantModal from "./CustomPlantModal"

import { fetchCustomPlants, saveCustomPlant, updateCustomPlant, deleteCustomPlant } from "../../store/goals/actions"
import { getProfile } from "../../store/auth/profile/actions"

const PlantsCustom = (props) => {
    const {
        customplants, profile,
        onGetCustomPlants, onGetProfile, onSaveCustomPlant, onUpdateCustomPlant, onDeleteCustomPlant,
    } = props

    const username = JSON.parse(localStorage.getItem("user") || "{}").user || ""

    const [customPlantModalOpen, setCustomPlantModalOpen] = useState(false)
    const [customPlantModalMode, setCustomPlantModalMode] = useState("create")
    const [currCustomPlant, setCurrCustomPlant] = useState(null)

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"))
        if (user) onGetProfile(user.user)
        onGetCustomPlants()
    }, [])

    function openCreateCustomPlantModal() {
        setCustomPlantModalMode("create")
        setCurrCustomPlant({
            id: uuidv4(),
            username,
            name: "",
            species: "",
            variety: "",
            season: "",
            germinationTime: "",
            plantFamily: "",
            spacing_between_plants: "",
            growingCycle: "",
            minimumTemperature: "",
            maximumTemperature: "",
            yieldPerPlant: "",
            size: "",
            numberOfPlants: "",
            daysToHarvest: "",
            climate: [],
            foodForestLayer: [],
            guildFunction: [],
            latinName: "",
            typeOfHarvest: "",
            USDAMin: "",
            USDAMax: "",
            designerIconKey: "",
            cardIconKey: "",
        })
        setCustomPlantModalOpen(true)
    }

    function openEditCustomPlantModal(customplant) {
        setCustomPlantModalMode("edit")
        setCurrCustomPlant(customplant)
        setCustomPlantModalOpen(true)
    }

    async function handleSaveCustomPlant(plant) {
        await onSaveCustomPlant(plant)
        onGetCustomPlants()
    }

    async function handleUpdateCustomPlant(plant) {
        await onUpdateCustomPlant(plant)
        onGetCustomPlants()
    }

    async function handleDeleteCustomPlant(plantId) {
        await onDeleteCustomPlant(plantId)
        onGetCustomPlants()
    }

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                                    <h4 style={{ margin: 0 }}>Custom Plants</h4>
                                    <button type="button" className="btn btn-sm" style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }} onClick={openCreateCustomPlantModal}>
                                        Add custom plant
                                    </button>
                                </div>

                                <Table responsive striped className="mb-0">
                                    <thead style={{ backgroundColor: "#BEC8B6" }}>
                                        <tr>
                                            <th>Name</th>
                                            <th>Lifecycle</th>
                                            <th>Size</th>
                                            <th>Days To Harvest</th>
                                            <th>Guild Function</th>
                                            <th>Food Forest Layer</th>
                                            <th>Image</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customplants.map((customplant) => (
                                            <tr key={customplant.id || customplant.species}>
                                                <td>{customplant.name || customplant.species}</td>
                                                <td>{customplant.season_rotation}</td>
                                                <td>{customplant.size}</td>
                                                <td>{customplant.daysToHarvest}</td>
                                                <td>{Array.isArray(customplant.guildFunction) ? customplant.guildFunction.join(", ") : customplant.guildFunction}</td>
                                                <td>{Array.isArray(customplant.foodForestLayer) ? customplant.foodForestLayer.join(", ") : customplant.foodForestLayer}</td>
                                                <td>
                                                    {customplant.cardIconKey ? (
                                                        <StorageImage
                                                            width="120px"
                                                            alt={`${customplant.species}-card-icon`}
                                                            imgKey={customplant.cardIconKey}
                                                            accessLevel="guest"
                                                            onStorageGetError={(error) => console.error(error)}
                                                        />
                                                    ) : customplant.icon ? (
                                                        <StorageImage
                                                            width="100px"
                                                            alt={`${customplant.species}-icon`}
                                                            imgKey={username + "-" + customplant.icon}
                                                            accessLevel="guest"
                                                            onStorageGetError={(error) => console.error(error)}
                                                        />
                                                    ) : null}
                                                </td>
                                                <td>
                                                    <Button onClick={() => openEditCustomPlantModal(customplant)} color="#FFFFFF" className="btn-sm">
                                                        <i className="fas fa-edit fa-2x" />
                                                    </Button>
                                                    <Button onClick={() => handleDeleteCustomPlant(customplant.id)} color="#FFFFFF" className="btn-sm" title="Delete">
                                                        <i className="fas fa-trash-alt fa-2x" />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <CustomPlantModal
                                    isOpen={customPlantModalOpen}
                                    toggle={() => setCustomPlantModalOpen((v) => !v)}
                                    username={username}
                                    mode={customPlantModalMode}
                                    initialPlant={currCustomPlant}
                                    onSave={handleSaveCustomPlant}
                                    onUpdate={handleUpdateCustomPlant}
                                    onDelete={handleDeleteCustomPlant}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const mapStateToProps = (state) => ({
    customplants: state.goals.customplants || [],
    profile: state.Profile.user,
})

const mapDispatchToProps = (dispatch) => ({
    onGetProfile: (username) => dispatch(getProfile(username)),
    onGetCustomPlants: () => dispatch(fetchCustomPlants()),
    onSaveCustomPlant: (plant) => dispatch(saveCustomPlant(plant)),
    onUpdateCustomPlant: (plant) => dispatch(updateCustomPlant(plant)),
    onDeleteCustomPlant: (id) => dispatch(deleteCustomPlant(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PlantsCustom)
